"use strict";
// Copyright (c) StrangeBee 2023
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ParentController_1 = __importDefault(require("../ParentController"));
class OrganisationController extends ParentController_1.default {
    constructor() {
        super(...arguments);
        this.endpoints = {
            create: '/v1/organisation',
            edit: '/v1/organisation/:objectId',
            setLinks: '/v1/organisation/:orgId/links',
            getSharingProfiles: '/v1/sharingProfile',
        };
    }
    delete() {
        throw new Error('Cannot delete organisations');
    }
    setLinks(links, orgId) {
        return this.manager.put({ url: this.endpoints.setLinks, params: { orgId } }, { links });
    }
    getSharingProfile() {
        return this.manager.get({
            url: this.endpoints.getSharingProfiles,
        });
    }
}
exports.default = OrganisationController;
